export enum UserRoles {
    SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
    USER = 'ROLE_USER',
}
